import {ChangeDetectorRef, Directive, EventEmitter, Input, OnDestroy, Output, ViewChild} from "@angular/core";
import {ControlValueAccessor, FormControl} from "@angular/forms";
import {FUIAbstractInput} from "./abstract-input";
import {FUIContextType} from "../../form-context/form-context-type";

@Directive()
export class FUIAbstractControl implements ControlValueAccessor, OnDestroy {
    @Input() public showAddOption: boolean;
    @Input() public showExtendedSearchOption: boolean;
    @Input() public showOptionOpenOption: boolean;
    @Output() public added$: EventEmitter<boolean>;
    @Output() public extended$: EventEmitter<boolean>;
    @Output() public optionOpened$: EventEmitter<any>;
    @Input() public control: FormControl;
    public contextType = FUIContextType; // Reference to FUIContextType so it can be used within the view
    @Input() public disabled: boolean;
    public focussed: boolean;
    @Output() public focussed$: EventEmitter<boolean>;
    @Input() public id: string;
    @ViewChild("input") public input: FUIAbstractInput;
    @Input() public label: string;
    @Input() labelI18NParams: any = {};
    @Input() public loading: boolean;
    @Input() name: string;
    @Input() public notation: string;
    @Input() public placeholder: string;
    public removed: boolean;
    @Output() public removed$: EventEmitter<boolean>;
    protected _value: any;
    @Output() public valueChange: EventEmitter<any>;
    private destroyed: boolean = false;

    constructor(protected changeDetectorRef: ChangeDetectorRef) {
        this.added$ = new EventEmitter<boolean>();
        this.control = new FormControl();
        this.extended$ = new EventEmitter<boolean>();
        this.optionOpened$ = new EventEmitter<any>();
        this.focussed$ = new EventEmitter<boolean>();
        this.removed$ = new EventEmitter<boolean>();
        this.valueChange = new EventEmitter<any>();
    }

    @Input()
    public set readOnly(readOnly: boolean) {
        this.disabled = readOnly;
    }

    public get readOnly(): boolean {
        return this.disabled;
    }

    ngOnInit(): void {

    }

    /**
     * Default click handling
     */
    public click(): void {
        if (this.input && !this.disabled) {
            this.input.click();
        }
    }

    /**
     * Set focus to an element
     * @param element
     */
    public focus(): void {
        if (this.input) {
            this.input.focus();
        }
    }

    public select():void {
        if (this.input) {
            this.input.selectAll();
        }
    }

    /**
     * When focus is removed from the input
     * @param event
     */
    public onBlur(event?: any): void {
        this.focussed = false;
        this.focussed$.emit(this.focussed);
    }

    /**
     * When focus is detected on the input
     * @param event
     */
    public onFocus(event?: any): void {
        this.focussed = true;
        this.focussed$.emit(this.focussed);
    }

    /**
     * When focussed$ event is emitted by the input
     * @param focussed
     */
    public onFocussed(focussed: boolean): void {
        this.focussed = focussed;
        this.focussed$.emit(this.focussed);
    }

    /**
     * Emit remove event
     * @param event
     */
    public remove(): void {
        this.removed = true;
        this.removed$.emit(this.removed);
    }

    /**
     *
     * @param _
     */
    public onChange = (_: any) => {

    };

    /**
     *
     */
    public onTouched = () => {

    };

    /**
     *
     * @returns {string}
     */
    get value(): any {
        return this._value;
    }

    valueEqual(value1: any, value2: any): boolean {
        return (this.isEmptyArray(value1) && this.isEmptyArray(value2)) || value1 == value2;
    }

    isEmptyArray(value: any): boolean {
        return (!!value) && (value.constructor === Array) && value.length === 0;
    }

    /**
     *
     * @param value
     */
    @Input()
    set value(value: any) {
        if (!this.valueEqual(value, this._value)) {
            this._value = value;
            this.onChange(value);
            this.valueChange.emit(value);
        }
    }

    /**
     *
     * @param fn
     */
    public registerOnChange(fn: (_: any) => void): void {
        this.onChange = fn;
    }

    /**
     *
     * @param fn
     */
    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    /**
     *
     * @param value
     */
    public writeValue(value: any): void {
        if (!this.destroyed) {
            this._value = value;
            this.changeDetectorRef.detectChanges();
        }
    }

    ngOnDestroy(): void {
        this.destroyed = true;
    }
}
